module.exports = __webpack_public_path__ + "media/images/add_icon_talana-d5718b76.png";